import { BaseResource } from '/@/modules/core/app/resources/BaseResource';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { AuthEnvironmentValueSetting } from '@/modules/auth/models/AuthEnvironmentValueSetting';
import { GenericModel } from '@/modules/core/app/models/GenericModel';
import { EnvValueSetting } from '@/modules/auth/models/interfaces/EnvValueSetting';

export class AuthEnvironmentValuesResource extends BaseResource {
  async fetchEnvironmentValues(): Promise<AuthEnvironmentValueSetting> {
    const data: GenericModel = await this.getData(Route.AUTH_ENVVALUES, GenericModel);

    return new AuthEnvironmentValueSetting({
      settings: JSON.parse(atob(data as string)) as EnvValueSetting
    });
  }
}

export default new AuthEnvironmentValuesResource();
